module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAAAKAgMAAAA/chPtAAAACVBMVEVodY6zusb////N8CKBAAAAL0lEQVQY02NYhRUsW7WKAbvMQpwyC7JwykjhlGHDKcO4igEXyMIpI4VThg2nDCMAuVlh1nUqu8oAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/public/icon-arrow-list@2x.png
// module id = 1129
// module chunks = 0